
{
  "familyId": "STU-KAART",
  "questions": [
    {
      "id": "STU-KAART-001",
      "familyId": "STU-KAART",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kaartlezen",
      "subSkill": "kaart_legenda_route",
      "questionType": "multiple_choice",
      "question": "Op een plattegrond staat een schaal van 1 : 5.000. Een straat is op de plattegrond 4 cm lang. Hoe lang is de straat in werkelijkheid?",
      "context": null,
      "options": ["200 meter", "20 meter", "2.000 meter", "50 meter"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Kaartschaal 1 : 5.000",
            "content": "Schaal 1 : 5.000 betekent: 1 cm op de kaart = 5.000 cm in werkelijkheid. De straat is 4 cm op de kaart.",
            "icon": "map"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kaartschaal berekenen",
            "content": "Schaal 1:5.000 betekent: 1 cm op de kaart = 5.000 cm in werkelijkheid. Bereken: 4 cm × 5.000 = 20.000 cm = 200 meter.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "map_scale_reading",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.kaart-alleen-1cm-vermenigvuldigd", "optionIndex": 1, "label": "Vermenigvuldigt alleen 1 cm i.p.v. hele kaartafstand" },
          { "id": "stu.kaart-cm-naar-meter-fout", "optionIndex": 2, "label": "Rekent cm verkeerd om naar meter (×10 i.p.v. ÷100)" },
          { "id": "stu.kaart-schaal-delen-ipv-vermenigvuldigen", "optionIndex": 3, "label": "Trekt of deelt schaal i.p.v. te vermenigvuldigen" }
        ]
      },
      "feedback": {
        "explanationText": "Schaal 1 : 5.000 betekent dat 1 cm op de kaart gelijk is aan 5.000 cm in werkelijkheid. De straat is 4 cm op de kaart, dus: 4 × 5.000 = 20.000 cm. Reken om naar meter: 20.000 ÷ 100 = 200 meter.",
        "solutionSteps": [
          "Lees de schaal af: 1:5.000 betekent 1 cm op de kaart = 5.000 cm in het echt",
          "Vermenigvuldig de kaartafstand met de schaal: 4 × 5.000 = 20.000 cm",
          "Reken om naar meter: 20.000 ÷ 100 = 200 meter"
        ],
        "distractorExplanations": {
          "0": "Goed! De straat is 200 meter lang: 4 × 5.000 = 20.000 cm = 200 m.",
          "1": "Je dacht waarschijnlijk dat je maar 1 cm hoeft te vermenigvuldigen. Maar de straat is 4 cm op de kaart, niet 1 cm. Bereken: 4 × 5.000 = 20.000 cm = 200 meter. Onthoud: vermenigvuldig de hele kaartafstand.",
          "2": "Je dacht waarschijnlijk dat 20.000 cm = 2.000 meter is. Maar 1 meter = 100 cm, dus 20.000 ÷ 100 = 200 meter. Onthoud: deel door 100 om van cm naar meter te gaan.",
          "3": "Je dacht waarschijnlijk dat je 5.000 door iets moet delen. Maar bij schaalberekening vermenigvuldig je: 4 × 5.000 = 20.000 cm = 200 meter. Onthoud: kaartafstand × schaal = echte afstand."
        }
      }
    },
    {
      "id": "STU-KAART-002",
      "familyId": "STU-KAART",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kaartlezen",
      "subSkill": "kaart_legenda_route",
      "questionType": "multiple_choice",
      "question": "Op een kaart staat een schaal van 1 : 10.000. Twee steden liggen 3 cm van elkaar op de kaart. Hoe ver liggen ze in werkelijkheid uit elkaar?",
      "context": null,
      "options": ["300 meter", "30 meter", "3.000 meter", "3 kilometer"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Kaartschaal 1 : 10.000",
            "content": "Schaal 1 : 10.000 betekent: 1 cm op de kaart = 10.000 cm in werkelijkheid. De afstand op de kaart is 3 cm.",
            "icon": "map"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kaartschaal berekenen",
            "content": "Schaal 1:10.000 betekent: 1 cm op de kaart = 10.000 cm in werkelijkheid. Bereken: 3 cm × 10.000 = 30.000 cm = 300 meter.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "map_scale_reading",
      "variantIndex": 2,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.kaart-alleen-1cm-vermenigvuldigd", "optionIndex": 1, "label": "Vermenigvuldigt alleen 1 cm i.p.v. hele kaartafstand" },
          { "id": "stu.kaart-cm-naar-meter-fout", "optionIndex": 2, "label": "Rekent cm verkeerd om naar meter" },
          { "id": "stu.kaart-eenheid-verward", "optionIndex": 3, "label": "Verwart kaartafstand met echte afstand in km" }
        ]
      },
      "feedback": {
        "explanationText": "Schaal 1 : 10.000 betekent dat 1 cm op de kaart gelijk is aan 10.000 cm in werkelijkheid. De afstand is 3 cm op de kaart, dus: 3 × 10.000 = 30.000 cm. Reken om naar meter: 30.000 ÷ 100 = 300 meter.",
        "solutionSteps": [
          "Lees de schaal af: 1:10.000 betekent 1 cm op de kaart = 10.000 cm in het echt",
          "Vermenigvuldig de kaartafstand met de schaal: 3 × 10.000 = 30.000 cm",
          "Reken om naar meter: 30.000 ÷ 100 = 300 meter"
        ],
        "distractorExplanations": {
          "0": "Goed! De afstand is 300 meter: 3 × 10.000 = 30.000 cm = 300 m.",
          "1": "Je dacht waarschijnlijk dat je maar 1 cm hoeft te vermenigvuldigen. Maar de afstand is 3 cm op de kaart. Bereken: 3 × 10.000 = 30.000 cm = 300 meter. Onthoud: vermenigvuldig de hele kaartafstand.",
          "2": "Je dacht waarschijnlijk dat 30.000 cm = 3.000 meter is. Maar 1 meter = 100 cm, dus 30.000 ÷ 100 = 300 meter. Onthoud: deel door 100 om van cm naar meter te gaan.",
          "3": "Je dacht waarschijnlijk dat 3 cm op de kaart = 3 kilometer is. Maar 3 km = 300.000 cm, en 3 × 10.000 = 30.000 cm = 300 meter. Onthoud: reken stap voor stap om."
        }
      }
    },
    {
      "id": "STU-KAART-003",
      "familyId": "STU-KAART",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kaartlezen",
      "subSkill": "kaart_legenda_route",
      "questionType": "multiple_choice",
      "question": "Op een kaart zie je deze symbolen in de legenda: een blauw vlak = water, een groen vlak = bos, een bruin driehoekje = berg. Wat betekent een bruin driehoekje op de kaart?",
      "context": null,
      "options": ["Daar ligt een berg.", "Daar is een bos.", "Daar is water.", "Daar is een stad."],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Legenda",
            "content": "Blauw vlak = water | Groen vlak = bos | Bruin driehoekje = berg",
            "icon": "map"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Legenda lezen",
            "content": "De legenda is het 'woordenboek' van een kaart. Elk symbool heeft een vaste betekenis. Kijk in de legenda: bruin driehoekje = berg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "map_legend_reading",
      "variantIndex": 3,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.kaart-legenda-kleur-assoc-bos", "optionIndex": 1, "label": "Associeert bruin met bos i.p.v. legenda te lezen" },
          { "id": "stu.kaart-legenda-kleur-assoc-water", "optionIndex": 2, "label": "Verwart kleurassociaties (bruin met water)" },
          { "id": "stu.kaart-legenda-aanname-zonder-kijken", "optionIndex": 3, "label": "Verzint betekenis zonder legenda te raadplegen" }
        ]
      },
      "feedback": {
        "explanationText": "De legenda vertelt wat elk symbool op de kaart betekent. Volgens de legenda staat een bruin driehoekje voor een berg. De legenda is het 'woordenboek' van de kaart — kijk altijd eerst in de legenda als je een symbool niet herkent!",
        "solutionSteps": [
          "Zoek het symbool op: bruin driehoekje",
          "Kijk in de legenda wat dit symbool betekent",
          "Legenda zegt: bruin driehoekje = berg",
          "Antwoord: daar ligt een berg"
        ],
        "distractorExplanations": {
          "0": "Goed! Volgens de legenda staat een bruin driehoekje voor een berg.",
          "1": "Je dacht waarschijnlijk dat bruin bij bos hoort. Maar in deze legenda is bos een groen vlak, niet een bruin driehoekje. Onthoud: kijk altijd in de legenda — kleuren en symbolen kunnen per kaart verschillen.",
          "2": "Je dacht waarschijnlijk dat bruin bij water hoort. Maar water is een blauw vlak in deze legenda. Bruin driehoekje = berg. Onthoud: blauw staat bijna altijd voor water op kaarten.",
          "3": "Je dacht waarschijnlijk dat een driehoekje een stad aangeeft. Maar een stad staat niet in deze legenda. Het bruine driehoekje staat voor een berg. Onthoud: een stad wordt vaak met een stip of cirkel aangegeven."
        }
      }
    },
    {
      "id": "STU-KAART-004",
      "familyId": "STU-KAART",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kaartlezen",
      "subSkill": "kaart_legenda_route",
      "questionType": "multiple_choice",
      "question": "Op een wegenkaart met schaal 1 : 50.000 meet je een afstand van 6 cm tussen twee dorpen. Hoe ver is dat in werkelijkheid?",
      "context": null,
      "options": ["3 kilometer", "300 meter", "30 kilometer", "6 kilometer"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Kaartschaal 1 : 50.000",
            "content": "Schaal 1 : 50.000 betekent: 1 cm op de kaart = 50.000 cm = 500 meter in werkelijkheid. De afstand op de kaart is 6 cm.",
            "icon": "map"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schaal omrekenen",
            "content": "Schaal 1:50.000 betekent: 1 cm = 50.000 cm = 500 meter. Dus 6 cm = 6 × 500 = 3.000 meter = 3 kilometer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "map_scale_larger",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.kaart-eenheid-km-vergeten", "optionIndex": 1, "label": "Vergeet eindomrekening naar km" },
          { "id": "stu.kaart-nullen-tellen-fout", "optionIndex": 2, "label": "Telt nullen in schaal verkeerd (×10 of ×100 mis)" },
          { "id": "stu.kaart-cm-gelijk-aan-km", "optionIndex": 3, "label": "Neemt aan dat cm op kaart = km in werkelijkheid" }
        ]
      },
      "feedback": {
        "explanationText": "Schaal 1 : 50.000 betekent dat 1 cm op de kaart = 50.000 cm = 500 meter in werkelijkheid. De afstand is 6 cm, dus: 6 × 500 = 3.000 meter = 3 kilometer. Onthoud: reken eerst de schaal om naar meter, dan vermenigvuldig je.",
        "solutionSteps": [
          "Schaal 1:50.000 → 1 cm = 50.000 cm",
          "Reken om: 50.000 cm = 500 meter",
          "Vermenigvuldig: 6 × 500 = 3.000 meter",
          "Reken om: 3.000 meter = 3 km"
        ],
        "distractorExplanations": {
          "0": "Goed! 6 cm × 50.000 = 300.000 cm = 3.000 m = 3 km.",
          "1": "Je dacht waarschijnlijk dat je maar 1 cm hoeft te vermenigvuldigen, of je bent vergeten om naar kilometer om te rekenen. De berekening is: 6 × 50.000 = 300.000 cm = 3.000 m = 3 km. Onthoud: vermenigvuldig de hele kaartafstand.",
          "2": "Je dacht waarschijnlijk dat de schaal 1:500.000 is. Maar de schaal is 1:50.000 (één nul minder). 6 × 50.000 = 300.000 cm = 3 km, niet 30 km. Onthoud: tel de nullen zorgvuldig.",
          "3": "Je dacht waarschijnlijk dat 6 cm op de kaart = 6 km is. Maar je moet vermenigvuldigen met de schaal: 6 × 50.000 = 300.000 cm = 3 km. Onthoud: de schaal bepaalt de omrekenfactor."
        }
      }
    },
    {
      "id": "STU-KAART-005",
      "familyId": "STU-KAART",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kaartlezen",
      "subSkill": "kaart_legenda_route",
      "questionType": "multiple_choice",
      "question": "Je bekijkt een kaart van een natuurgebied. De legenda toont: stippellijn = wandelpad, doorgetrokken lijn = fietspad, dubbele lijn = autoweg. Welk pad mag je NIET met de auto gebruiken?",
      "context": null,
      "options": [
        "Het wandelpad en het fietspad.",
        "Alleen het wandelpad.",
        "Alleen het fietspad.",
        "Alle paden mogen met de auto."
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Legenda",
            "content": "Stippellijn = wandelpad | Doorgetrokken lijn = fietspad | Dubbele lijn = autoweg",
            "icon": "map"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Legenda interpreteren",
            "content": "De legenda geeft aan welk type weg elk symbool voorstelt. Een autoweg (dubbele lijn) is voor auto's. Een wandelpad en fietspad zijn niet voor auto's.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "map_legend_interpret",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.kaart-legenda-onvolledig-wandel", "optionIndex": 1, "label": "Leest legenda onvolledig: alleen wandelpad uitgesloten" },
          { "id": "stu.kaart-legenda-onvolledig-fiets", "optionIndex": 2, "label": "Leest legenda onvolledig: alleen fietspad uitgesloten" },
          { "id": "stu.kaart-legenda-symbool-onderscheid-gemist", "optionIndex": 3, "label": "Mist onderscheid tussen padtypen in legenda" }
        ]
      },
      "feedback": {
        "explanationText": "Volgens de legenda is alleen de dubbele lijn een autoweg. Het wandelpad (stippellijn) en het fietspad (doorgetrokken lijn) zijn niet bedoeld voor auto's. Je mag dus met de auto alleen de autoweg gebruiken — zowel het wandelpad als het fietspad zijn verboden voor auto's.",
        "solutionSteps": [
          "Lees de legenda: welke wegen zijn er?",
          "Wandelpad (stippellijn) = voor wandelaars, niet voor auto's",
          "Fietspad (doorgetrokken lijn) = voor fietsers, niet voor auto's",
          "Autoweg (dubbele lijn) = voor auto's ✓",
          "Antwoord: wandelpad én fietspad zijn niet voor auto's"
        ],
        "distractorExplanations": {
          "0": "Goed! Zowel het wandelpad als het fietspad zijn niet voor auto's — alleen de autoweg (dubbele lijn) is voor auto's.",
          "1": "Je dacht waarschijnlijk dat alleen het wandelpad verboden is voor auto's. Maar ook het fietspad is niet voor auto's. Alleen de autoweg (dubbele lijn) is voor auto's. Onthoud: lees alle symbolen in de legenda.",
          "2": "Je dacht waarschijnlijk dat alleen het fietspad verboden is voor auto's. Maar ook het wandelpad is niet voor auto's. Alleen de autoweg (dubbele lijn) is voor auto's. Onthoud: zowel wandelpaden als fietspaden zijn niet voor auto's.",
          "3": "Je dacht waarschijnlijk dat alle wegen voor auto's zijn. Maar de legenda maakt onderscheid: wandelpad = wandelaars, fietspad = fietsers, autoweg = auto's. Onthoud: elk symbool heeft een specifieke betekenis."
        }
      }
    }
  ]
}
